export default class Display {

	constructor(args) {
		this.system = args.system;
		this.elem = args.elem;
		this.container = null; // root PIXI container 
		this.stage = null; // Scene(s) live here
	}

	init() {
		//
	}

	resize(width, height, scaleFactor) {
		//
	}

	render(delta, deltaNormal) {
		// I'm a display and I'm rendering stuff
		// Sometimes I might need frame delta for fancy things
	}

	toggleFullscreen() {
		//
	}

	stopAudio() {
		//
	}

	resumeAudio() {
		//
	}

}